module.exports = __webpack_public_path__ + "static/media/BADGER-BTCB.41c067ba.svg";